import { BackendDateFormat, parseDate } from '@/utils/helpers';

export const NOW_DATE_FLAG_PREFIX = '#ALL$UseDate';

export const buildNowDateFlag = (nowDate?: string | null): string | undefined => {
  if (!nowDate || !parseDate(nowDate, BackendDateFormat)) {
    return undefined;
  }

  return `${NOW_DATE_FLAG_PREFIX}${nowDate}`;
};

export const getNowDateFlags = (nowDate?: string | null): string[] => {
  const flag = buildNowDateFlag(nowDate);

  return flag ? [flag] : [];
};

export const excludeNowDateFlags = (flags?: string[] | null): string[] =>
  flags?.filter(flag => !flag.startsWith(NOW_DATE_FLAG_PREFIX)) ?? [];

export const getNowDateFlagsFromRequest = (flags?: string[] | null): string[] =>
  flags?.filter(flag => flag.startsWith(NOW_DATE_FLAG_PREFIX)) ?? [];
